import React from "react";
import { useMsal } from "@azure/msal-react";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { Card } from "react-bootstrap";
import { Toggle } from "@fluentui/react/lib/Toggle";
import axios from "../configuration/axios";

export const UserCard = (props) => {
  const { instance } = useMsal();
  const {
    userName,
    userEmail,
    userGuid,
    isAdmin,
    setIsAdmin,
    isActive,
    removeUser,
    popUp,
    setPopUp,
    setToDeleteUserId,
    setToDeleteUserGuid,
    isSuperAdmin,
    subscriptionId,
    setTokenExpired,
    setUsersState,
  } = props;

  const setAdminRights = async (isAdmin) => {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
      },
    };
    const bodyParameters = {
      userName: userName,
      userEmail: userEmail,
      userGuid: userGuid,
      isAdmin: isAdmin,
      subscriptionId: subscriptionId,
      superAdmin: isSuperAdmin,
    };
    await axios
      .put(
        axios.defaults.baseURL + "/LicenseManager/SetAdminRights",
        bodyParameters,
        config
      )
      .then((result) => {
        setTokenExpired(false);
        setIsAdmin(userGuid, result.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setTokenExpired(true);
        }
      });
  };

  async function toggleAdminRights(event) {
    if(event.target.checked == true) {
      await setAdminRights(false);
    }
    else {
      await setAdminRights(true)
    }
  }

  return (
    <Card style={{ width: "50rem", marginTop: "2.5vh" }}>
      <Card.Body style={{ padding: "1.5vh 1.5vw" }}>
        <Card.Title>{userName}</Card.Title>
        <Card.Text style={{ marginBottom: "2vh" }}>{userEmail}</Card.Text>
        <Toggle
          label="Can manage licenses"
          checked={isAdmin}
          disabled={isSuperAdmin}
          onText="Yes"
          offText="No"
          onChange={(event) => toggleAdminRights(event)}
        />
      </Card.Body>
      <Card.Footer style={{ backgroundColor: "white", padding: "1vh 1vw" }}>
        {!isSuperAdmin ? (
          <DefaultButton
            style={{ padding: "0.8vh 1vw" }}
            text="Remove"
            onClick={() => {
              setPopUp(true);
              setToDeleteUserId(setToDeleteUserId);
              setToDeleteUserGuid(userGuid);
            }}
          ></DefaultButton>
        ) : null}
      </Card.Footer>
    </Card>
  );
};
